import { Shot } from '@/types/greenroom/shots.types';
import { Post } from '../helpers';

const LoadGreenroomShots = async (meetingId: number, token: string): Promise<Shot[] | null> => {
  return Post({
    host: import.meta.env.VITE_GREENROOM_API,
    url: '/v2/greenroom/shots/load',
    body: { meetingId },
    headers: {
      'bl-token': token,
      'bl-global-resource': 'false',
    },
    useCache: true,
    cacheTtl: 60,
  });
};

export default LoadGreenroomShots;
